import React from "react";
import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery";
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import ListItems from "./ListItems.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

library.add(faTrash);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      currentItem: {
        text: "",
        key: "",
      },
    };
    this.handleInput = this.handleInput.bind(this);
    this.addItem = this.addItem.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.editItem = this.editItem.bind(this);
  }

  handleInput(e) {
    this.setState({
      currentItem: {
        text: e.target.value,
        key: Date.now(),
      },
    });
  }

  deleteItem(key) {
    const newItems = this.state.items.filter((item) => item.key !== key);
    this.setState({
      items: newItems,
    });
  }

  editItem(value, key) {
    const items = this.state.items;
    items.map((item) => {
      if (item.key === key) {
        item.text = value;
      }
    });
    this.setState({
      items: items,
    });
  }

  addItem(e) {
    e.preventDefault();
    const newItem = this.state.currentItem;
    console.log(newItem);
    if (newItem.text !== "") {
      const newItems = [...this.state.items, newItem];
      this.setState({
        items: newItems,
        currentItem: {
          text: "",
          key: "",
        },
      });
    }
  }
  render() {
    return (
      <div className="row">
        <div className="App">
          <header className=" m-5">
            <form
              onSubmit={this.addItem}
              className="form-inline justify-content-center py-3"
            >
              <div className="form-group">
                <input
                  className="form-control mr-2"
                  type="text"
                  placeholder="Enter Text"
                  id="to-do-input"
                  value={this.state.currentItem.text}
                  onChange={this.handleInput}
                />
              </div>

              <button className="btn btn-primary" type="submit">
                Add
              </button>
            </form>
          </header>
          <ListItems
            deleteItem={this.deleteItem}
            items={this.state.items}
            editItem={this.editItem}
          ></ListItems>
        </div>
      </div>
    );
  }
}

export default App;
